<div class="content">
  <app-rich-text-form #noteForm [note]="data.note"></app-rich-text-form>
</div>

<div class="footer">
  <button pButton (click)="closeDialog()">Cancel</button>
  <button pButton (click)="onSubmit()" [disabled]="!isFormValid">{{ btnLabel }} Note</button>
</div>
